import App from '@modules/husleie-framework/src/static-classes/App.class.js';
import type {
  ContractAPIInterface,
  ContractGet,
  ContractGetResponse,
  ContractCreate,
  ContractCreateResponse,
  ContractUpdate,
  ContractUpdateResponse,
  ContractPreview,
  ContractPreviewResponse,
  ContractDownload,
  ContractDownloadResponse,
  ContractSigningMethodGet,
  ContractSigningMethodGetResponse,
  ContractReadyForSigning,
  ContractReadyForSigningResponse,
  ContractPendingSignaturesGet,
  ContractPendingSignaturesGetResponse,
  ContractFeedback,
} from '@modules/store/contract/types/ContractAPI.interface';
import APIMocked from './index.mock-api';
import APIReal from './index.real-api';

export default class API implements ContractAPIInterface {
  private readonly api: any;

  constructor() {
    this.api = App.isMockedAPI() ? new APIMocked() : new APIReal();
  }

  getContract(get: ContractGet): Promise<ContractGetResponse> {
    return this.api.getContract(get);
  }

  createContract(create: ContractCreate): Promise<ContractCreateResponse> {
    return this.api.createContract(create);
  }

  updateContract(update: ContractUpdate): Promise<ContractUpdateResponse> {
    return this.api.updateContract(update);
  }

  updateContractTenantDetails(update: ContractUpdate): Promise<ContractUpdateResponse> {
    return this.api.updateContractTenantDetails(update);
  }

  fetchContractPreview(preview: ContractPreview): Promise<ContractPreviewResponse> {
    return this.api.fetchContractPreview(preview);
  }

  getContractDownloadUrl(download: ContractDownload): Promise<ContractDownloadResponse> {
    return this.api.getContractDownloadUrl(download);
  }

  sendContractForTenantSigning(sign: ContractReadyForSigning): Promise<ContractReadyForSigningResponse> {
    return this.api.sendContractForTenantSigning(sign);
  }

  sendContractTenantFeedback(feedback: ContractFeedback): Promise<void> {
    return this.api.sendContractTenantFeedback(feedback);
  }

  async getContractSigningMethod(get: ContractSigningMethodGet): Promise<ContractSigningMethodGetResponse> {
    return this.api.getContractSigningMethod(get);
  }

  getContractPendingSignatures(
    pendingSignatures: ContractPendingSignaturesGet
  ): Promise<ContractPendingSignaturesGetResponse> {
    return this.api.getContractPendingSignatures(pendingSignatures);
  }

  async signContract(contractId: string, signatureId: string, fileToken: string): Promise<boolean> {
    return this.api.signContract(contractId, signatureId, fileToken);
  }

  async confirmOfflineContractSigning(contractId: string): Promise<void> {
    return this.api.confirmOfflineContractSigning(contractId);
  }
}
